import React, {useEffect, useState} from 'react';
import {Checkbox, Divider, Form, Modal, Select, Typography} from 'antd';
import {CATEGORIAS, TIPOS_PERSONA} from '../constant';
import {useTranslation} from "react-i18next";
import {Table} from 'antd';

import './formModal.scss';
import formTypeValidator from "../../../helpers/formTypeValidator";

const {Option} = Select;

const FormConfigModal = ({currentUser, onCancel, onOk, form, dataTemplate}) => {
    const {getFieldDecorator, setFieldsValue} = form;
    const {t} = useTranslation();

    const [useExisistingVersion, setUseExisistingVersion] = useState(false);
    const [isValidatorDuplicity, setIsValidatorDuplicity] = useState(false);
    const [formValid, setFormValid] = useState(false);
    const [baseTemplate, setBaseTemplate] = useState(null);
    const [canUseExisting, setCanUseExisting] = useState(false);


    const handleSubmit = (e) => {
        e.preventDefault();
        form.validateFields((error, values) => {
            if (error) return;
            useExisistingVersion ? onOk(values, null, baseTemplate) : onOk(values);
        });
    };

    useEffect(() => {
        const tipoDeclaracion = form.getFieldValue('tipoDeclaracion');
        if (!tipoDeclaracion || !Array.isArray(dataTemplate)) {
            setCanUseExisting(false);
            return;
        }
        const hasExistingTemplates = dataTemplate.some((template) => template.tipoDeclaracion === tipoDeclaracion );
        setCanUseExisting(hasExistingTemplates);

        setUseExisistingVersion(false);
        setBaseTemplate(null);

    }, [form.getFieldValue('tipoDeclaracion'), dataTemplate]);

    useEffect(() => {
        if (useExisistingVersion && dataTemplate?.tipoDeclaracion) {
            setFieldsValue({tipoDeclaracion: dataTemplate.tipoDeclaracion});
        }
    }, [useExisistingVersion, dataTemplate, setFieldsValue]);

    const getTypeDeclarationOptions = (usarExistente) => {
        let validTypes = formTypeValidator(currentUser, null, false);
        const declarations = Array.isArray(dataTemplate) ? dataTemplate.map(x => x.tipoDeclaracion) : [];

        if(currentUser.modules.includes('ONBOARDING') && currentUser.cliente.modules.includes('ONBOARDING')){
            validTypes = [...validTypes, "KYC"]
        }

        const filteredTypes = usarExistente
            ? validTypes.filter(type => declarations.includes(type))
            : validTypes;

        return filteredTypes.map(type => (
            <Option key={type} value={type}>
                {t(`messages.aml.type.${type}`)}
            </Option>
        ));
    };

    const isDuplicateCombination = (declaracion, categoria, tipoPersona) => {

        if (!declaracion || !tipoPersona || !categoria) {
            declaracion = form.getFieldValue('tipoDeclaracion');
            categoria = form.getFieldValue('categoria');
            tipoPersona = form.getFieldValue('tipoPersona');
        }
        return dataTemplate.some(template =>
            template.tipoDeclaracion === declaracion &&
            template.categoria === categoria &&
            template.tipoPersona === tipoPersona
        );
    };

    const getFormValidationMessage = () => {
        if (formValid) {
            const tipoDeclaracion = form.getFieldValue('tipoDeclaracion');
            const categoria = form.getFieldValue('categoria');
            const tipoPersona = form.getFieldValue('tipoPersona');

            const matchedTemplate = dataTemplate.find(template =>
                template.tipoDeclaracion === tipoDeclaracion &&
                template.categoria === categoria &&
                template.tipoPersona === tipoPersona
            );

            if (matchedTemplate) {
                return (
                    <div style={{color: 'red', marginTop: 8}}>
                        Ya existe una plantilla con esta combinación.
                        ID: <strong>{matchedTemplate.identificador}</strong>
                    </div>
                );
            }
        }
    }

    useEffect(() => {
        const {tipoDeclaracion, categoria, tipoPersona} = form.getFieldsValue([
            'tipoDeclaracion', 'categoria', 'tipoPersona'
        ]);

        const allFilled = tipoDeclaracion && categoria && tipoPersona;
        const hasErrors = Object.values(form.getFieldsError()).some(errors => errors && errors.length > 0);

        setFormValid(allFilled && !hasErrors);
    }, [form.getFieldsValue(['tipoDeclaracion', 'categoria', 'tipoPersona']), form.getFieldsError()]);

    const columns = [
            {
                title: 'ID',
                dataIndex: 'identificador',
                key: 'identificador',
                sorter: (a, b) => a.identificador - b.identificador,
                defaultSortOrder: 'ascend',
                width: '15%',
            },
            {
                title: 'Categoría',
                dataIndex: 'categoria',
                key: 'categoria',
                render: (val) => t('messages.aml.category.' + val),
                width: '35%',
            },
            {
                title: 'Tipo Persona',
                dataIndex: 'tipoPersona',
                key: 'tipoPersona',
                render: (val) => t('messages.aml.typePerson.' + val),
                width: '35%',
            },
    ];

    const handleChangeCheckExistingVersion = (e) => {
        setUseExisistingVersion(e.target.checked)
        setBaseTemplate(null)
    }

    const getFilteredCategories = () => {
        const tipoDeclaracion = form.getFieldValue('tipoDeclaracion');
        if (!tipoDeclaracion) return [];
        return formTypeValidator(currentUser, null, false, tipoDeclaracion);
    };

    const filteredData = dataTemplate.filter(item => item.tipoDeclaracion === form.getFieldValue('tipoDeclaracion') );

    const tipoDeclaracionSelected = !!form.getFieldValue('tipoDeclaracion');

    const handleTipoDeclaracionChange =() => {
        setUseExisistingVersion(false);
        setBaseTemplate(null);

        setFieldsValue({
            categoria: undefined,
            tipoPersona: undefined,
        });
    }

    return (
        <Modal
            visible={true}
            title={t('messages.aml.form.template.create.template.title')}
            okText={t('messages.aml.create')}
            cancelText={t("messages.aml.cancel")}
            onCancel={onCancel}
            onOk={handleSubmit}
            destroyOnClose
            okButtonProps={{disabled: (!formValid || isValidatorDuplicity || isDuplicateCombination())}}
        >
            <Form layout="vertical" onSubmit={handleSubmit}>
                <Form.Item label={t('messages.aml.form.template.tipo.declaracion')}>
                    {getFieldDecorator('tipoDeclaracion', {
                        rules: [{required: true, message: t('messages.aml.form.template.tipo.declaracion')}],
                    })(
                        <Select
                            placeholder={t('messages.aml.form.template.placeholder.tipo.declaracion')}
                            allowClear
                            onChange={handleTipoDeclaracionChange}
                        >
                            {getTypeDeclarationOptions(useExisistingVersion)}
                        </Select>
                    )}
                </Form.Item>

                <Form.Item>
                    <Checkbox
                        checked={useExisistingVersion}
                        onChange={handleChangeCheckExistingVersion}
                        disabled={!canUseExisting}
                    >
                        {t('messages.aml.form.template.use.previous.version')}
                    </Checkbox>
                </Form.Item>

                {useExisistingVersion && form.getFieldValue('tipoDeclaracion') && (
                    <>
                        <Typography.Text type="secondary" style={{marginBottom: 8, display: 'block'}}>
                            Plantillas existentes con este tipo de declaración:
                        </Typography.Text>
                        <Table
                            dataSource={filteredData}
                            rowKey="identificador"
                            size="small"
                            bordered
                            pagination={false}
                            scroll={{y: 120}}
                            rowClassName={(record) => baseTemplate && record.identificador === baseTemplate.identificador ? 'selected-row' : ''
                            }
                            onRow={(record) => ({
                                onClick: () => {
                                    setFieldsValue({
                                        tipoDeclaracion: record.tipoDeclaracion,
                                        categoria: undefined,
                                        tipoPersona: undefined,
                                    });
                                    setBaseTemplate(record);
                                    form.validateFields(['tipoDeclaracion', 'categoria', 'tipoPersona'], {force: true});
                                },
                            })}
                            columns={columns}
                        />
                    </>
                )}

                <Divider orientation="left"/>

                <Form.Item label={t("messages.aml.category")}>
                    {getFieldDecorator('categoria', {
                        rules: [
                            {required: true, message: t('messages.aml.form.template.validation.categoria')},
                            {
                                validator: (_, value, callback) => {
                                    const declaracion = form.getFieldValue('tipoDeclaracion');
                                    const tipoPersona = form.getFieldValue('tipoPersona');
                                    const categoria = form.getFieldValue('categoria');

                                    const isDuplicate = isDuplicateCombination(declaracion, categoria, tipoPersona);
                                    setIsValidatorDuplicity(isDuplicate);
                                    callback();
                                }
                            }
                        ],
                    })(
                        <Select placeholder={t('messages.aml.form.template.placeholder.categoria')}
                                disabled={!tipoDeclaracionSelected}
                                onChange={(value) => {
                                    form.setFieldsValue({categoria: value});
                                    const tipoPersona = form.getFieldValue('tipoPersona');
                                    const tipoDeclaracion = form.getFieldValue('tipoDeclaracion');
                                    const isDuplicate = isDuplicateCombination(tipoDeclaracion, value, tipoPersona);
                                    setIsValidatorDuplicity(isDuplicate);
                                }}
                        >
                            {getFilteredCategories().length> 0  && <Option key="ALL" value="ALL">{t('messages.aml.category.ALL')}</Option>}
                            {getFilteredCategories().map((category) => (
                                <Option key={category} value={category}>{t('messages.aml.category.' + category)}</Option>
                            ))}
                        </Select>
                    )}
                </Form.Item>

                <Form.Item label={t('messages.aml.form.template.tipo.persona')}>
                    {getFieldDecorator('tipoPersona', {
                        rules: [
                            {required: true, message: t('messages.aml.form.template.placeholder.tipo.persona')},
                            {
                                validator: (_, value, callback) => {
                                    const declaracion = form.getFieldValue('tipoDeclaracion');
                                    const tipoPersona = form.getFieldValue('tipoPersona');
                                    const categoria = form.getFieldValue('categoria');

                                    const isDuplicate = isDuplicateCombination(declaracion, categoria, tipoPersona);
                                    setIsValidatorDuplicity(isDuplicate);
                                    callback();
                                }
                            }
                        ],
                    })(
                        <Select placeholder={t('messages.aml.form.template.placeholder.tipo.persona')}
                                disabled={!tipoDeclaracionSelected}
                                onChange={(value) => {
                                    form.setFieldsValue({tipoPersona: value});
                                    const tipoPersona = form.getFieldValue('tipoPersona');
                                    const tipoDeclaracion = form.getFieldValue('tipoDeclaracion');
                                    const isDuplicate = isDuplicateCombination(tipoDeclaracion, value, tipoPersona);
                                    setIsValidatorDuplicity(isDuplicate);
                                }}>
                            {TIPOS_PERSONA.map((tipo) => (
                                <Option key={tipo} value={tipo}>{t('messages.aml.typePerson.' + tipo)}</Option>
                            ))}
                        </Select>
                    )}
                </Form.Item>

                {getFormValidationMessage()}
            </Form>
        </Modal>
    );
};

export default Form.create()(FormConfigModal);
